var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#D4AD89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.09 23.666H10.3333C10.1123 23.666 9.90036 23.7538 9.74408 23.9101C9.5878 24.0664 9.5 24.2783 9.5 24.4993C9.5 24.7204 9.5878 24.9323 9.74408 25.0886C9.90036 25.2449 10.1123 25.3327 10.3333 25.3327H23.6667C23.8877 25.3327 24.0996 25.2449 24.2559 25.0886C24.4122 24.9323 24.5 24.7204 24.5 24.4993C24.5 24.2783 24.4122 24.0664 24.2559 23.9101C24.0996 23.7538 23.8877 23.666 23.6667 23.666H21.91C21.7042 21.3543 21.0175 17.3243 18.7217 16.166C20.8583 14.9802 21.5992 12.1577 21.8583 10.3327H23.6667C23.8877 10.3327 24.0996 10.2449 24.2559 10.0886C24.4122 9.93232 24.5 9.72036 24.5 9.49935C24.5 9.27834 24.4122 9.06637 24.2559 8.91009C24.0996 8.75381 23.8877 8.66602 23.6667 8.66602H10.3333C10.1123 8.66602 9.90036 8.75381 9.74408 8.91009C9.5878 9.06637 9.5 9.27834 9.5 9.49935C9.5 9.72036 9.5878 9.93232 9.74408 10.0886C9.90036 10.2449 10.1123 10.3327 10.3333 10.3327H12.1417C12.4008 12.1577 13.1417 14.9802 15.2783 16.166C12.9825 17.3243 12.2958 21.3543 12.09 23.666ZM14.5 20.8327C14.5 19.8327 17 17.8327 17 17.8327C17 17.8327 19.5 19.8327 19.5 20.8327V23.666H14.5V20.8327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/Timer.059178e9b40f50521c70d9bd5f8d37f1.svg";
export { ForwardRef as ReactComponent };